export enum EnergyType {
  ELECTRICITY = 'electricity',
  GAS = 'gas',
}
